import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Translate } from '../../shared/LanguageService';
import DroneBookingsWarningContent from '../photographers/DroneBookingsWarningContent';
import IUpcomingDroneBooking from '../photographers/IUpcomingDroneBooking';

type DroneBookingsWarningDialogProps = {
    open: boolean;
    bookings: IUpcomingDroneBooking[];
    onConfirm: () => void;
    onClose: () => void;
};

export function DroneBookingsWarningDialog({
    open,
    bookings,
    onConfirm,
    onClose
}: DroneBookingsWarningDialogProps) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                {Translate('photographers/drone/upcoming-bookings/confirmation/title')}
            </DialogTitle>
            <DialogContent>
                <DroneBookingsWarningContent
                    bookings={bookings}
                    textKey="profile/drone/upcoming-bookings/confirmation/text"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {Translate('photographers/drone/upcoming-bookings/confirmation/cancel-button')}
                </Button>
                <Button color="error" onClick={onConfirm}>
                    {Translate('photographers/drone/upcoming-bookings/confirmation/do-button')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DroneBookingsWarningDialog;
